import { IconButton, Tooltip } from '@mui/material'
import React from 'react'

// process tooltip and disabled props
function TableActions({ row, actions }) {
  return (
    <div>
      {actions.map((action, index) => (
        action.disabled ? <div key={index}></div> : (
        <Tooltip key={index} title={action.tooltip || ''} arrow>
          <IconButton onClick={(event) => action.onClick(row.original)}>
            {action.icon}
          </IconButton>
        </Tooltip>
      )))}
    </div>
  )
}

export default TableActions